export const reduceByMax = (key) => (max, item) =>
  Math.max(max, item[key] || 0);
